import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
import axios from 'axios'
Vue.use(Router)

// vue-router 3.1 부터 push/replace 가 Promise 를 반환한다. 같은 경로로 다시 이동하면
// NavigationDuplicated 로 reject 되는데, 잡지 않으면 콘솔이 오류로 뒤덮이고 일부
// 브라우저에서는 이후 이동이 멎는다. 설치본은 3.5.2 라 해당된다(2026-09-25).
// 🔴 사용자가 넘긴 콜백이 있으면 원래 동작을 그대로 둔다 — 콜백형은 Promise 를 안 준다.
const _push = Router.prototype.push
const _replace = Router.prototype.replace
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return _push.call(this, location, onResolve, onReject)
  return _push.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return err
    throw err
  })
}
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return _replace.call(this, location, onResolve, onReject)
  return _replace.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return err
    throw err
  })
}

const requireAuth = () => (to, from, next) => {
  console.log('to: ', to);
  if(store.state.AppActiveUser.id){ //유저정보가 있으면 토큰만 갱신
    console.log('user data OK')
    axios.get('/api/login/check')
    .then(data => {
      axios.defaults.headers.common['token'] = data.data.newtoken;
      store.commit('LOGIN', data.data.newtoken)
      return next();
    }).catch(function() {
      // 🔴 `next()` 없이 `router.push` 만 하면 **현재 내비게이션이 끝나지 않는다.**
      //    그 상태에서 새 이동이 겹치면 vue-router 가 NavigationDuplicated 를 던지고,
      //    기사작성창에서는 이탈 가드와 맞물려 팝업 무한루프로 번진다(2026-09-25).
      //    가야 할 곳을 next() 로 넘기고, replace 로 히스토리에 로그인을 남기지 않는다.
      next({ path: '/pages/login', query: Object.assign({ to: to.path }, to.query), replace: true })
    })
  }else{ //유저정보가 없으면 유저정보도 받아옴
    console.log('No user data')
    axios.get('/api/login/checkAndData')
    .then(data => {
      store.commit('LOGIN', data.data.newtoken)
      store.commit('USERSTATE', data.data.user)
      axios.defaults.headers.common['token'] = data.data.newtoken;
      return next()
    }).catch(function() {
      // 위와 같은 이유 — next() 로 넘긴다.
      next({ path: '/pages/login', query: Object.assign({ to: to.path }, to.query), replace: true })
    })
  }
  // if (store.getters.isAuthenticated) {
  //   // console.log(store.getters.isAuthenticated)
  //   return next()
  // }
  // // console.log(store.getters.isAuthenticated)
  // router.push('/pages/login?to='+to.path)
}
// const requireAuthBanner = () => (to, from, next) => {
//   if(store.state.AppActiveUser.id){ //유저정보가 있으면 토큰만 갱신
//     console.log('user data OK')
//     axios.get('/api/bannerManager/login/check')
//     .then(data => {
//       axios.defaults.headers.common['token'] = data.data.newtoken;
//       store.commit('bannerManagerLOGIN', data.data.newtoken)
//       return next();
//     }).catch(function() {
//       router.push({path: '/bannerManager/login?to='+to.path, query: to.query})
//     })
//   }else{ //유저정보가 없으면 유저정보도 받아옴
//     console.log('No user data')
//     axios.get('/api/bannerManager/login/checkAndData')
//     .then(data => {
//       // console.log('check ok1')
//       store.commit('bannerManagerLOGIN', data.data.newtoken)
//       // console.log('check ok2')
//       store.commit('bannerManagerUSERSTATE', data.data.user)
//       // console.log('check ok3')
//       axios.defaults.headers.common['bannertoken'] = data.data.newtoken;
//       return next()
//     }).catch(function() {
//       // console.log('check fail')
//       router.push({path: '/bannerManager/login?to='+to.path, query: to.query})
//     })
//   }
// }
const logout = () => () => {
  if(store.state.AppActiveUser.level == 1) { store.dispatch('LOGOUT').then(() => {router.push('/bannerManager/login')}); }
  else { store.dispatch('LOGOUT').then(() => {router.push('/pages/login')}); }
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

      {
    // =============================================================================  1
    // MAIN LAYOUT ROUTES
    // =============================================================================
        path: '',
        component: () => import('./layouts/main/Main.vue'),
        children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
          {
            path: '/',
            redirect: '/pages/login'
          },
          {
            path: '/center/',
            redirect: '/pages/login'
          },
          // views/test/* 화면 세 개를 2026-09-04 에 라우터에서 전부 뺐다.
          //   /test/writeArticles  기사작성테스트  — cdn.jasm.co.kr 4곳,
          //                        그리고 실화면에서 지운 페이스북·트위터 문구 항목이 남아 있다
          //   /test/newsListAll    뉴스리스트테스트 — permission.sns FB/TW 컬럼이 남아 있다
          //   /test/newsPlace      뉴스배치테스트  — cdn.jasm.co.kr 25곳(화살표 8곳은 CDN 양쪽 404,
          //                        썸네일은 thumb 이 thumbnail/ 인 신규 기사에서 깨진다)
          // 셋 다 실화면(views/WriteArticles.vue · NewsList.vue · NewsPlace.vue)의 옛 버전이라
          // 열면 지운 항목이 보이거나 이미지가 깨진다. 사이드바에는 노출되지 않았지만
          // URL 로는 접근할 수 있었다. 화면 파일은 참고용으로 남겼다.
          {
            path: '/newsList',
            redirect: '/newsListAll'
          },
          {
            path: '/member/common',
            name: '일반회원 관리',
            component: () => import('./views/MemberCommon.vue'),
            beforeEnter: requireAuth()
          },
          // 배너 슬롯 — 면별로 화면을 나눈다. 같은 컴포넌트에 page prop 만 다르게 준다.
          // 옛 /ad/member, /ad/mains, /ad/sides, /ad/header, /ad/footer 는 데일리안의
          // ad_banner* 4단 조인 설계였고 테이블이 전부 비어 있었다 — 2026-09-15 에 걷어냈다.
          {
            path: '/ad/common',
            name: '배너 - 공통',
            component: () => import('./views/adSlot/AdSlots.vue'),
            props: { page: 'common' },
            beforeEnter: requireAuth()
          },
          {
            path: '/ad/home',
            name: '배너 - 메인홈',
            component: () => import('./views/adSlot/AdSlots.vue'),
            props: { page: 'home' },
            beforeEnter: requireAuth()
          },
          {
            path: '/ad/article',
            name: '배너 - 기사면',
            component: () => import('./views/adSlot/AdSlots.vue'),
            props: { page: 'article' },
            beforeEnter: requireAuth()
          },
          {
            path: '/ad/list',
            name: '배너 - 목록면',
            component: () => import('./views/adSlot/AdSlots.vue'),
            props: { page: 'list' },
            beforeEnter: requireAuth()
          },
          // {
          //   path: '/bannerManager/main',
          //   name: '메인영역',
          //   component: () => import('./views/AdSourceMains.vue'),
          //   beforeEnter: requireAuthBanner()
          // },
          // {
          //   path: '/bannerManager/sidebar',
          //   name: '사이드바',
          //   component: () => import('./views/AdSourceSides.vue'),
          //   beforeEnter: requireAuthBanner()
          // },
          // {
          //   path: '/bannerManager/header',
          //   name: '상단',
          //   component: () => import('./views/AdSourceHeader.vue'),
          //   beforeEnter: requireAuthBanner()
          // },
          // {
          //   path: '/bannerManager/footer',
          //   name: '하단',
          //   component: () => import('./views/AdSourceFooter.vue'),
          //   beforeEnter: requireAuthBanner()
          // },
          {
            path: '/member/reporter',
            name: '기자 관리',
            component: () => import('./views/MemberReporter.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/newsListDeleted',
            name: '삭제뉴스리스트',
            component: () => import('./views/NewsListDeleted.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/newsListAll',
            name: '뉴스리스트',
            component: () => import('./views/NewsList.vue'),
            beforeEnter: requireAuth()
          },
          // {
          //   path: '/newsListDesk',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          // {
          //   path: '/newsListG1',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          // {
          //   path: '/newsListG2',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          // {
          //   path: '/newsListG3',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          // {
          //   path: '/newsListG6',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          // {
          //   path: '/newsListG7',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          // {
          //   path: '/newsListG4',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          // {
          //   path: '/newsListG5',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          // {
          //   path: '/newsListG8',
          //   name: '뉴스리스트',
          //   component: () => import('./views/NewsList.vue'),
          //   beforeEnter: requireAuth()
          // },
          {
            path: '/photoArticle',
            name: '기사사진',
            component: () => import('./views/photoArticle.vue'),
            beforeEnter: requireAuth()
          },
          // /photoDB · /addPhoto 는 2026-09-06 에 삭제했다. 데일리안 포토DB(`photo`
          // 테이블) 화면인데 중앙신문 스키마에 그 테이블이 없어 등록도 조회도 안 됐다.
          // 사진은 기사작성(유형=포토)으로 만들고 /photoArticle 에서 본다.
          {
            path: '/newsPlace',
            name: '뉴스배치',
            component: () => import('./views/NewsPlace.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/leaveRequest',
            name: '휴가신청',
            component: () => import('./views/LeaveRequest.vue'),
            beforeEnter: requireAuth()
          },
          {
            // 연차 통계 · 사용촉진(근로기준법 제61조). 데스크 이상만 데이터가 온다
            // (서버 /api/leave/stats 가 level>=8 을 확인한다).
            path: '/leaveStats',
            name: '연차통계',
            component: () => import('./views/LeaveStats.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/writeArticles',
            name: '기사작성',
            component: () => import('./views/WriteArticles.vue'),
            beforeEnter: requireAuth()
          },
          {
            // 통신사 수신함(연합뉴스). 기사작성 참고용 목록이고 article 을 만들지 않는다.
            path: '/wireList',
            name: '연합뉴스',
            component: () => import('./views/WireList.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/setting',
            name: '설정',
            component: () => import('./views/Setting.vue'),
            beforeEnter: requireAuth()
          },
          {path: '/statistics/legacy/desc', component: () => import('./views/StatisticsDesc.vue'), beforeEnter: requireAuth()},
          {path: '/statistics/legacy/eachReporter', component: () => import('./views/StatisticsEachReporter.vue'), beforeEnter: requireAuth()},
          {path: '/statistics/legacy/myOwn', component: () => import('./views/StatisticsDescMyOwn.vue'), beforeEnter: requireAuth()},
          {path: '/statistics/legacy/days', component: () => import('./views/StatisticsDays.vue'), beforeEnter: requireAuth()},
          {path: '/statistics/legacy/month', component: () => import('./views/StatisticsMonth.vue'), beforeEnter: requireAuth()},
          {
            path: '/statistics/desc',
            name: '통계 조회수 순',
            component: () => import('./views/StatisticsUnified.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/statistics/eachReporter',
            name: '통계 작성자별',
            component: () => import('./views/StatisticsUnified.vue'),
            beforeEnter: requireAuth()
          },
          {  
            path: '/statistics/myOwn',
            name: '통계',
            component: () => import('./views/StatisticsUnified.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/statistics/days',
            name: '날짜별 통계',
            component: () => import('./views/StatisticsUnified.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/statistics/month',
            name: '월별 통계',
            component: () => import('./views/StatisticsUnified.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/statistics/traffic',
            name: '방문자·봇 통계',
            redirect: '/statistics/days',
            beforeEnter: requireAuth()
          },
          {
            path: '/board',
            name: '게시판',
            component: () => import('./views/board.vue'),
            beforeEnter: requireAuth()
          },
          {
            path: '/writePost',
            name: '게시판 글작성',
            component: () => import('./views/writePost.vue'),
            beforeEnter: requireAuth()
          },
          // 데일리안 근태 화면(/Overtime · /RequestingTimeOff · /timeOffDashboard
          // · /accessDashboard)은 2026-09-04 에 라우터에서 뺐다.
          // 전부 board.js 를 통해 **데일리안 newetc DB(bd_timeoff 등)** 를 조회한다 —
          // 열면 중앙신문이 아닌 데일리안 직원 데이터가 보인다.
          // 중앙신문 휴가는 /leaveRequest(신청) · /leaveStats(통계·사용촉진)를 쓴다.
          // 화면 파일은 참고용으로 남겨 두었다(views/OverTime.vue 등).
          // 단체메일(/Mailing · /MailStats)은 2026-09-06 에 걷어냈다. 중앙신문은
          // 메일링을 쓰지 않는다. 서버의 /api/mail 라우터도 함께 삭제했다.
          {
            path: '/pages/logout',
            name: '로그아웃',
            beforeEnter: logout()
          },
        ],
      },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
      {
        path: '',
        component: () => import('@/layouts/full-page/FullPage.vue'),
        children: [
      // =============================================================================
      // PAGES
      // =============================================================================
          {
            path: '/pages/login',
            name: 'pageLogin',
            component: () => import('@/views/pages/Login.vue')
          },
          {
            path: '/pages/error-404',
            name: 'pageError404',
            component: () => import('@/views/pages/Error404.vue')
          },
          {
            path: '/bannerManager/login',
            name: 'bannerLogin',
            component: () => import('@/views/bannerManager/Login.vue')
          },
          // /pages/overtimeStat 도 같은 이유로 뺐다(데일리안 newetc DB).
        ]
      },
      // Redirect to 404 page, if no match found
      {
        path: '*',
        redirect: '/pages/error-404'
      }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

// router.beforeEach((to, from, next) => {
//   // if (store.getters.isAuthenticated) return next()
//   // router.push({ path: '/pages/login', query: { to: to.path } })
//   // router.push('/pages/login')
//   return next()
// });

// ── 히스토리 이동 (2026-09-27) ─────────────────────────────────────────────
// 🔴 **새로고침 직후에는 "이전 페이지"가 없다.** vue-router 의 시작 라우트는
//    `path: '/'` 에 `matched: []` 인데, 이걸 이전 페이지로 삼으면
//    `{ path: '/', redirect: '/pages/login' }` 때문에 **로그인 화면으로 튄다.**
//    실제로 "기사작성 완료 후 로그인 화면으로 돌아간다"가 이것이었다 —
//    로그인이 풀린 게 아니라 돌아갈 곳이 로그인으로 잡힌 것이다.
//    `$router.back()` / `go(-1)` 도 같은 문제를 갖는다. 새로고침 뒤에는 브라우저
//    히스토리의 이전 항목이 CMS 밖일 수도 있다.

// 이 라우트가 "돌아가도 되는 앱 안의 실제 페이지"인가.
export function isRealRoute(r) {
  return !!(r && r.matched && r.matched.length
            && r.path && r.path !== '/'
            && r.path.indexOf('/pages/login') !== 0)
}

// 페이지를 연 뒤 앱 안에서 한 번이라도 이동했는가. 이게 false 면 뒤로 갈 곳이 없다.
let movedInApp = false
router.afterEach(function (to, from) {
  if (isRealRoute(from)) movedInApp = true
})

// 뒤로 간다. 갈 곳이 없으면 fallback 으로 보낸다.
export function safeBack(fallback) {
  if (movedInApp) return router.go(-1)
  return router.push({ path: fallback || '/newsList' })
}

// from 이 쓸 만하면 그리로, 아니면 fallback 으로.
export function backTo(from, fallback) {
  if (isRealRoute(from)) {
    return router.push({ path: from.path, query: from.query || {} })
  }
  return router.push({ path: fallback || '/newsList' })
}

export default router
